import React from 'react';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemSection } from './components/ProblemSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { Curriculum } from './components/Curriculum';
import { ContentPreview } from './components/ContentPreview';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { BackedBy } from './components/BackedBy';
import { Guarantee } from './components/Guarantee';
import { Format } from './components/Format';
import { FAQ } from './components/FAQ';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalOffer } from './components/FinalOffer';
import { FinalCTA } from './components/FinalCTA';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="w-full min-h-full bg-ink-950 pb-20 font-sans text-white lg:pb-0" data-id="element-0" data-mp="3rbrayrj641gc">
      <PromoBar data-id="element-1" data-mp="5otf64sd496" />
      <main data-id="element-2" data-mp="67znpl2q47d">
        <Hero data-id="element-3" data-mp="4wwnrzgd0hb" />
        <StatsBar data-id="element-4" data-mp="5gfdawxfswe" />
        <ProblemSection data-id="element-5" data-mp="82k72sfnuax" />
        <WhoIsItFor data-id="element-6" data-mp="2zld0z6e9z99y" />
        <ContentPreview data-id="element-7" data-mp="2zlv84y2h77wn" />
        <Curriculum data-id="element-8" data-mp="2zmo557bmuj1l" />
        <Bonuses data-id="element-9" data-mp="2zn6biws0edn8" />
        <OfferStack data-id="element-10" data-mp="33mow1rfx4mpj" />
        <Testimonials data-id="element-11" data-mp="33m5bs42spm8c" />
        <AboutAuthor data-id="element-12" data-mp="33ngdzzglelxc" />
        <BackedBy data-id="element-13" data-mp="33myl9ct52pu6" />
        <Guarantee data-id="element-14" data-mp="33oi152avuyvf" />
        <Format data-id="element-15" data-mp="38m1iwc6shts4" />
        <FAQ data-id="element-16" data-mp="38li6fazwrxlh" />
        <BeforeAfter data-id="element-17" data-mp="38l05w267qx7r" />
        <FinalOffer data-id="element-18" data-mp="38kgocmkh6au9" />
        <FinalCTA data-id="element-19" data-mp="3dkuuu06fhcq6" />
        <Contact data-id="element-20" data-mp="3dle2mo2d6kqh" />
      </main>
      <Footer data-id="element-21" data-mp="3dlnru9fl4nv4" />
      <StickyBuyBar data-id="element-22" data-mp="3dm5z013scmht" />
      <PurchaseNotifications data-id="element-23" data-mp="3dii530ufhy2k" />
    </div>;
}